export default function Hero() {
  return (
    <section className="relative h-screen min-h-[900px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c9191cb18f17d9a4f043d06d3beb21fb.jpg"
          alt="Masaje de Vida - Ambiente profesional"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2C3E2F]/80 via-[#2C3E2F]/70 to-[#2C3E2F]/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <h1 className="font-serif text-6xl md:text-7xl font-medium text-white leading-tight mb-8">
            Recupera tu bienestar en las mejores manos de Getafe
          </h1>
          
          <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-xl">
            20 años de experiencia transformando el estrés en vitalidad. Masajes profesionales, terapéuticos y relajantes en un ambiente diseñado para tu descanso.
          </p>

          <a
            href="#reserva"
            className="inline-flex items-center px-10 py-4 bg-[#A8B5A0] text-white text-lg font-semibold rounded-full hover:bg-[#8fa089] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap"
          >
            <i className="ri-calendar-line mr-3 text-xl"></i>
            Reserva tu cita ahora - 643 218 449
          </a>

          <div className="mt-8 flex items-center">
            <div className="flex text-yellow-400 text-xl">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </div>
            <p className="ml-4 text-white italic text-sm">
              "Lo mejor de la Comunidad de Madrid" - Javier G.
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Text */}
      <div className="absolute bottom-12 left-0 right-0 pointer-events-none">
        <p className="text-white/15 font-sans font-black text-[120px] md:text-[180px] text-center leading-none">
          BIENESTAR
        </p>
      </div>
    </section>
  );
}
